import { trustHTML } from "@ember/template";
import PluginOutlet from "discourse/components/plugin-outlet";
import bodyClass from "discourse/helpers/body-class";

export default <template>
  {{bodyClass "static-privacy"}}

  <section class="container">
    <div class="contents clearfix body-page">
      <PluginOutlet @name="above-static" />
      {{trustHTML @controller.model.html}}
      <PluginOutlet @name="below-static" />
    </div>
  </section>
</template>
